import { render, staticRenderFns } from "./AgeComparatorFieldInput.vue?vue&type=template&id=140c05eb&"
import script from "./AgeComparatorFieldInput.vue?vue&type=script&lang=js&"
export * from "./AgeComparatorFieldInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports